import React from 'react';

import { browserHistory } from 'react-router';

import './style.css';

const IssueFinished = props => {
  return (
    <div className="IssueFinished d-flex justify-content-center">
      <div className="card mb-4 mt-4">
        <div className="title mb-4">THANK YOU</div>
        <p>Thank you for taking the time to report this issue.</p>
        <p>{props.location.state.message}</p>
        <p>
          You can contact us any time with questions, issues, or feedback at{' '}
          <a href="mailto:help@rypeapp.com">help@rypeapp.com</a>.
        </p>
        <div className="mt-4">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              browserHistory.push({
                pathname: '/schedule-lesson'
              });
            }}
          >
            Schedule your next lesson
          </button>
        </div>
      </div>
    </div>
  );
};

export default IssueFinished;



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/routes/IssueFinished/index.js